const VALUE = 'value';
const KEY = 'key';

export { KEY, VALUE };
